export const Environement = Object.freeze({
  BASE_API_URL: 'https://api.pressroom.escalconsulting.com',
});
